export const HOTEL_481_SUBSIDIARY_ID = '08dbd965-1fae-4e2c-8242-74ac6dcb242f'

export function isHotel481(hotelId) {
  if (!hotelId) {
    return false
  }

  const normalizedHotelId = String(hotelId).toLowerCase()

  return (
    normalizedHotelId === HOTEL_481_SUBSIDIARY_ID.toLowerCase() ||
    normalizedHotelId === '481'
  )
}

export function isCheckoutDateOptionalForHotel(hotelId) {
  return isHotel481(hotelId)
}

export function getRequiredTagIdsForCategory(category, hotelId) {
  let requiredTagIds

  if (category.includes('Lost')) {
    requiredTagIds = ['__hotelName__', '__guestName__', '__checkoutDate__']
  } else if (category.includes('AfterLastVisit')) {
    requiredTagIds = ['__hotelName__', '__guestName__', '__checkoutDate__']
  } else if (category === 'OptInRequest') {
    requiredTagIds = ['__hotelName__', '__promoName__']
  } else if (category === 'AlreadySubscribed') {
    requiredTagIds = ['__hotelName__']
  } else {
    requiredTagIds = ['__hotelName__', '__guestName__']
  }

  if (isCheckoutDateOptionalForHotel(hotelId)) {
    return requiredTagIds.filter(tagId => tagId !== '__checkoutDate__')
  }

  return requiredTagIds
}

export function getRequiredTagIdsForCustomCampaign(hotelId) {
  return ['__hotelName__', '__guestName__']
}
